<template>
    <van-popup v-model:show="show" style="background: rgba(0,0,0,0);" closeable @close="read" close-icon="clear">
        <div class="popup-box">
            <div class="content">
                <img class="tztopbg" src="@/assets/images/kyctc.svg" alt="">
                <div class="h1">{{t('notifyPopupKyc.a1')}}</div>
                <!-- <p class="con">恭喜您注册成功,请立即前往实名认证!</p> -->
                <van-button type="default" class="btn" @click="read(true)">
                    {{t('notifyPopupKyc.a2')}}
                </van-button>
            </div>
        </div>
    </van-popup>
</template>

<script setup>
import { readNoticeApi } from "@/api"
import { ref, watch } from 'vue';
import { useI18n } from "vue-i18n"
import { useMainStore } from "@/store"
import { useRouter } from 'vue-router';
const router = useRouter()

const mainStore = useMainStore()
const { t } = useI18n()

const props = defineProps({
    show: Boolean,
    data: { type: Array, default: () => { } },
})


const emit = defineEmits(["update:show"])

const show = ref(props.show)

watch(() => props.show, v => show.value = v)
watch(show, v => emit("update:show", v))

const read = async (e) => {
    try {
        const res = await readNoticeApi({
            id: props.data.id
        });
        if (e) {
            router.push('/realNameAuthentication')
        }
    } catch (error) {
        console.error(error);
    }
};
</script>


<style scoped lang="scss">
:deep(.van-badge__wrapper) {
    top: 50px;
    left: calc(100% - 30px);
}

.popup-box {
    width: 90vw;
    max-width: 350px;
    padding-top: 44px;

    .content {
        border-radius: 20px;
        background-color: #FFF;
        position: relative;
        padding-top: 44px;
        padding: 60px 16px 20px 16px;
        background-image: url("@/assets/images/tzbg.png");
        background-repeat: no-repeat;
        background-size: 100%;
        background-position: top;

        .tztopbg {
            width: 90px;
            position: absolute;
            left: 0;
            right: 0;
            top: -45px;
            margin: auto;
        }

        .h1 {
            color: #000;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 18px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
            margin-bottom: 12px;
        }

        .con {
            color: #666;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 400;
            line-height: 24px;
        }

        .btn {
            margin-top: 16px;
            width: 100%;
            border-radius: 10px;
            background: #2969FF;
            border-color: #2969FF;
            color: #FFF;
            text-align: center;
            font-family: "Microsoft YaHei UI";
            font-size: 16px;
            font-style: normal;
            font-weight: 700;
            line-height: normal;
        }
    }
}
</style>